import { EmptyState, MenuList, MenuListItem } from '@nexus/ui';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../i18n/format';
import { noteText, useReleaseNotes } from './release-notes';

const LIST_LENGTH = 5;

/** The latest changes of the app; the page "Was ist neu" has all of them with hints. */
export function WhatsNewTile() {
  const { t, i18n } = useTranslation();
  const notes = useReleaseNotes();
  if (notes.length === 0) {
    return (
      <EmptyState
        compact
        icon="megaphone"
        title={t('whatsNew.emptyTitle')}
        description={t('whatsNew.emptyDescription')}
      />
    );
  }
  return (
    <MenuList aria-label={t('whatsNew.title')}>
      {notes.slice(0, LIST_LENGTH).map((note) => (
        <MenuListItem
          key={note.id}
          href={`/whats-new#${note.id}`}
          description={
            <time dateTime={note.date}>{formatDate(new Date(note.date), i18n.language)}</time>
          }
        >
          {noteText(note, i18n.language).title}
        </MenuListItem>
      ))}
    </MenuList>
  );
}
